import React, { useEffect, useState } from "react";
import {
  Box,
  TextField,
  Grid,
  Button,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { handleAxiosError } from "../../../config/action-config";
import { showAlert } from "../../../actions/alert";
import { Controller, useForm } from "react-hook-form";
import { updateLeave } from "../../../api/leaves";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

export default function ViewLeaveDetail({ preloadedValues, refresh }) {
  const user = useSelector((state) => state.user);
  const [dayOffChange, setDayOffChange] = useState(false);
  const [previousDayOff, setPreviousDayOff] = useState("");
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm({ defaultValues: preloadedValues });

  async function onLeaveUpdate(newdata) {
    if (previousDayOff === "Full Day") {
      newdata.end_date = createDateAsUTC(newdata.end_date);
    }
    try {
      const { data } = await updateLeave(params.id, newdata, user.token);
      setDayOffChange(false);
      setPreviousDayOff("");
      refresh();
      // loadMasterData();
      dispatch(showAlert(data.msg));
      navigate(-2);
    } catch (error) {
      handleAxiosError(error, dispatch);
      setDayOffChange(false);
    }
  }
  useEffect(() => {
    if (preloadedValues.day_off === "Half Day") {
      setDayOffChange(true);
    } else {
      setValue("end_date", preloadedValues.end_date);
      setDayOffChange(false);
    }
  }, [preloadedValues.day_off]);
  return (
    <Box sx={{ flexGrow: 1 }}>
      <Paper sx={{ p: "1rem" }}>
        <Box
          component="form"
          onSubmit={handleSubmit(onLeaveUpdate)}
          sx={{
            display: "flex",
            pb: 1,
            mb: 1,
            // borderBottom: 1,
            justifyContent: "space-between",
          }}
        >
          <Grid container spacing={2} sx={{ pt: "1rem" }}>
            {/* <Grid item xs={12} md={6} sm={6}>
              <TextField
                name="name"
                label="Name"
                required
                fullWidth
                inputRef={register({
                  required: "Name is required.",
                })}
                error={Boolean(errors.name)}
                helperText={errors.name?.message}
              />
            </Grid> */}

            <Grid item xs={12} md={6} sm={6}>
              <FormControl
                fullWidth
                required
                error={Boolean(errors.type_of_leave)}
              >
                <InputLabel id="leave-type-label">Type Of Leave</InputLabel>
                <Controller
                  render={(props) => (
                    <Select
                      value={props.value}
                      onChange={props.onChange}
                      MenuProps={{ className: "select-box-height" }}
                    >
                      <MenuItem value="" disabled>
                        --select--
                      </MenuItem>
                      <MenuItem value="Casual Leave">Casual Leave</MenuItem>
                      <MenuItem value="Privilege Leave">
                        Privilege Leave
                      </MenuItem>
                      <MenuItem value="Sick Leave">Sick Leave</MenuItem>
                    </Select>
                  )}
                  name="type_of_leave"
                  label="Type Of Leave"
                  control={control}
                  rules={{
                    required: "Type of Leave is required.",
                  }}
                />
                <FormHelperText>{errors.type_of_leave?.message}</FormHelperText>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6} sm={6}>
              <FormControl fullWidth required error={Boolean(errors.day_off)}>
                <InputLabel id="leave-type-label">Day Off</InputLabel>
                <Controller
                  render={(props) => (
                    <Select
                      value={props.value}
                      onChange={(e) => {
                        props.onChange(e);
                        if (e.target.value === "Half Day") {
                          setDayOffChange(true);
                        } else {
                          setDayOffChange(false);
                        }
                        setPreviousDayOff(e.target.value);
                      }}
                      MenuProps={{ className: "select-box-height" }}
                    >
                      <MenuItem value="" disabled>
                        --select--
                      </MenuItem>
                      <MenuItem value="Full Day">Full Day</MenuItem>
                      <MenuItem value="Half Day">Half Day</MenuItem>
                      {/* <MenuItem value="Day Off">Day Off</MenuItem> */}
                    </Select>
                  )}
                  name="day_off"
                  label="Day Off"
                  control={control}
                  rules={{
                    required: "Day Off is required.",
                  }}
                />
                <FormHelperText>{errors.day_off?.message}</FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6} sm={6}>
              <FormControl fullWidth error={Boolean(errors.start_date)}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <Controller
                    render={(props) => (
                      <DesktopDatePicker
                        value={props.value || ""}
                        // shouldDisableDate={disablePrevDates(
                        //   dayjs(new Date()).subtract(1, "days").toJSON()
                        // )}
                        label="Start Date"
                        onChange={props.onChange}
                        renderInput={(params) => (
                          <TextField
                            error={Boolean(errors.start_date)}
                            {...params}
                          />
                        )}
                      />
                    )}
                    rules={{
                      required: "Start Date is required.",
                    }}
                    name="start_date"
                    control={control}
                  />
                </LocalizationProvider>
                <FormHelperText>{errors.start_date?.message}</FormHelperText>
              </FormControl>
            </Grid>
            {dayOffChange ? (
              <></>
            ) : (
              <Grid item xs={12} md={6} sm={6}>
                <FormControl fullWidth error={Boolean(errors.end_date)}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <Controller
                      render={(props) => (
                        <DesktopDatePicker
                          value={props.value || ""}
                          // shouldDisableDate={disablePrevDates(
                          //   dayjs(new Date()).subtract(1, "days").toJSON()
                          // )}
                          label="End Date"
                          onChange={props.onChange}
                          renderInput={(params) => (
                            <TextField
                              error={Boolean(errors.end_date)}
                              {...params}
                            />
                          )}
                        />
                      )}
                      rules={{
                        required: "End Date is required.",
                      }}
                      name="end_date"
                      control={control}
                    />
                  </LocalizationProvider>
                  <FormHelperText>{errors.end_date?.message}</FormHelperText>
                </FormControl>
              </Grid>
            )}
            <Grid item xs={12} md={12} sm={12}>
              <TextField
                name="reason_of_leave"
                multiline={true}
                rows={5}
                label="Reason of Leave"
                required
                fullWidth
                inputRef={register({
                  required: "Reason of Leave is required.",
                })}
                error={Boolean(errors.reason_of_leave)}
                helperText={errors.reason_of_leave?.message}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "right",
                  columnGap: 1,
                  ml: "auto",
                }}
              >
                <Button
                  variant="contained"
                  onClick={() => {
                    setPreviousDayOff("");
                    navigate(-2);
                  }}
                  className="blue-button"
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  // onClick={handleSubmit(onLeaveUpdate)}
                  type="submit"
                  style={{ padding: "5px 7px" }}
                  className="blue-button"
                >
                  Update
                </Button>
                {/* <Button
                variant="contained"
                onClick={() => {
                  setOpen(true);
                }}
                style={{ padding: "5px 7px" }}
              >
                Delete
              </Button> */}
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </Box>
  );
}
function disablePrevDates(startDate) {
  const startSeconds = Date.parse(startDate);
  return (date) => {
    return Date.parse(date) < startSeconds;
  };
}
function createDateAsUTC(date) {
  return new Date(
    Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds()
    )
  );
}
